import { FilterSearchBar, Table } from '@/components';
import {
  companyNameColumnConfig,
  costColumnConfig,
  recurrenceColumnConfig,
  statusColumnConfig,
  typeColumnConfig,
} from '@/utils';
import { amountColumnConfig } from '@/utils/tableColumns/amount-column.config';
import { ReactElement, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TabContext } from '../TabContainer';
import { TableRow } from '../Table/types';

interface InfrastructureCostsTabProps {
  disableFields?: string[];
  context?: 'companyDetails' | 'organizationDetails';
}

export const InfrastructureCostsTab = ({
  context,
}: InfrastructureCostsTabProps): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: infrastructure_costs,
    isLoading: isLoadinginfrastructure_costs,
    page,
    onPageChange,
    handleSearchChange,
    onSort,
  } = useContext(TabContext);

  const routeChange = (row?: TableRow) => {
    const path = `/infrastructure-costs/${row?.id}`;
    navigate(path);
  };

  const columns = useMemo(() => {
    const baseColumns = [
      costColumnConfig({}),
      typeColumnConfig(),
      amountColumnConfig(),
      recurrenceColumnConfig(),
      statusColumnConfig(),
    ];

    if (context == 'organizationDetails') {
      baseColumns.splice(1, 0, companyNameColumnConfig());
    }

    return baseColumns;
  }, [context]);

  return (
    <>
      <div className="center flex flex-row">
        <FilterSearchBar
          total={infrastructure_costs?.totalRows || 0}
          title={t('infrastructure_costs')}
          onSearch={handleSearchChange}
          variant={'secondary'}
        />
      </div>
      <Table
        onRowClick={routeChange}
        columns={columns}
        rows={infrastructure_costs?.items ?? []}
        isLoading={isLoadinginfrastructure_costs}
        noResultsLabel={t('no_costs_available')}
        withPagination
        totalItems={infrastructure_costs?.totalRows}
        totalPages={infrastructure_costs?.totalPages}
        currentPage={page}
        onSort={onSort}
        onPageChange={onPageChange}
      />
    </>
  );
};
